import { LoadingCard } from "commonUI/LoadingListCards";


const LoadingIndicator = () => {
    return <>
        <div className="limit-reached" style={{ background: 'transparent' }}>
            <div className="flex flex-col items-center gap-5 w-full">
                <LoadingCard className="h-4 w-20" />
                <LoadingCard className="h-4 w-1/2 " />
            </div>
            <LoadingCard className="h-8 w-20" />
        </div>
    </>
}

export default LoadingIndicator;